import { defineStore } from "pinia";

export const useErrorStore = defineStore("error", {
  state: () => ({
    errorMessage: "",
    loginTypeError: false,
  }),
  actions: {
    setErrorMessage(message: string) {
      this.errorMessage = message;
    },
    clearErrorStore() {
      this.errorMessage = "";
    },
    setLoginTypeError(value: boolean) {
      this.loginTypeError = value;
    },
  },
  getters: {
    getErrorMessage: (state) => state.errorMessage,
    getLoginTypeError: (state) => state.loginTypeError,
  },
});
